module.exports = __webpack_public_path__ + "static/media/query.ad2ef0a5.svg";